module.exports = __webpack_public_path__ + "img/move.3089690d.svg";